import $ from 'jquery';

const setIsMobile = () => {
  return (window.innerWidth < 768) ? true : false;
};

const setUa = () => {
  const w = window;
  let ua = {};
  ua.name      = w.navigator.userAgent.toLowerCase();
  ua.isIE      = (ua.name.indexOf('msie') >= 0 || ua.name.indexOf('trident') >= 0);
  ua.isiPhone  = ua.name.indexOf('iphone') >= 0;
  ua.isiPod    = ua.name.indexOf('ipod') >= 0;
  ua.isiPad    = ua.name.indexOf('ipad') >= 0;
  ua.isiOS     = (ua.isiPhone || ua.isiPod || ua.isiPad);
  ua.isAndroid = ua.name.indexOf('android') >= 0;
  ua.isTablet  = (ua.isiPad || (ua.isAndroid && ua.name.indexOf('mobile') < 0));
  ua.isPc      = (!ua.isiOS || ua.isAndroid || ua.isTablet);
  return ua;
};

const setViewport  = (ua,width) => {
  const $viewport = $('meta[name=viewport]', $('head'));
  let w     = width || 1200,
      value = 'width=device-width, initial-scale=1';
  value = (ua.isTablet) ? 'width='+w : value;
  $viewport.attr('content',value);
};

const setAnchor = (offset) => {
  const speed = 500,
        url = $(location).attr('href'),
        $body = $('html,body');
  let trg, trgpos;
  offset = offset || 0;
  $('a[href^="#"]').each(function() {
    const $this = $(this);
    $this.on('click',function(e) {
      e.preventDefault();
      if ($this.hasClass('js-movieModal')) { return false; }
      if ($this.attr('href').indexOf('megaMenu') !== -1) { return false; }
      trg    = $(this).attr('href');
      trgpos = trg !== '#top' && $(trg).offset().top;
      if (trg === '#top') {
        $body.animate({scrollTop: 0}, speed);
      }
      $body.animate({scrollTop: (trgpos - offset)}, speed);
    });
  });
  if(url.indexOf("?id=") != -1){
      const id      = url.split("?id="),
            $target = $('#' + id[id.length - 1]);
      let pos;
      if($target.length){
          pos = $target.offset().top;
          $body.animate({scrollTop:pos - offset}, speed);
      }
  }
};

const setToTop = (_scroll) => {
  $('.toTop').toggleClass('is-active', _scroll > 20);
};

module.exports = {
  setIsMobile : setIsMobile,
  setUa       : setUa,
  setViewport : setViewport,
  setAnchor   : setAnchor,
  setToTop    : setToTop
};



// WEBPACK FOOTER //
// ./src/js/modules/defaults.js